import { styled } from '@biome-design-system/styles';
import { MapProviderCardList } from '@kyruus/provider-components';

export const StyledMapProviderCardList = styled(MapProviderCardList)`
  position: absolute;
  transform: translate(-50%, -50%);
  background: white;
  'box-shadow': 0 8px 32px rgba(0, 0, 0, 0.24);
  transition: opacity 0.2s ease-out;
  height: fit-content;
  'overflow-y': auto;
  width: 240px;
  height: fit-content;
  max-height: 80%;
  z-index: 2001;
  top: 50%;
  left: 50%
`;
